import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { SpinnerService, Message } from 'shared-components';
import { GestionService } from "../../../services/gestion.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from 'rxjs';

@Component({
    selector: 'app-dns-new-edit',
    templateUrl: './new-edit.component.html'
})
export class DnsNewEditComponent implements OnInit {

    private _denominacion;
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();
    public disabled: Subject<boolean> = new Subject();
    public etiquetasCaja;
    public etiquetasPallet;
    public grupoEtiquetasCaja;
    public grupoEtiquetasPallet;

    @Input() denominacionId;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', Validators.required],
            productoId: ['', Validators.required],
            alias: [''],
            permisoLectura: [true, Validators.required],
            disenyoEtiquetasIdCaja: ['', Validators.required],
            disenyoEtiquetasIdPallet: ['', Validators.required],
            grupoEtiquetasIdCaja: ['', Validators.required],
            grupoEtiquetasIdPallet: [''],
            nombreArchivoImagen: [''],
            denominacionIntegracionId: ['']
        });

        this.etiquetasCaja = this.etiquetas.filter(x => x.tipoConfeccionId === 1);
        this.etiquetasPallet = this.etiquetas.filter(x => x.tipoConfeccionId === 2);

        this.grupoEtiquetasCaja = this.grupoEtiquetas.filter(x => x.tipoConfeccionId === 1);
        this.grupoEtiquetasPallet = this.grupoEtiquetas.filter(x => x.tipoConfeccionId === 2);

        if (this.denominacionId) {
            this.getDenominacion();
        }
    }

    public get grupoEtiquetas() {
        return this._dataProvider.grupoEtiquetas;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get etiquetas() {
        return this._dataProvider.etiquetas;
    }

    public get productos() {
        return this._dataProvider.productos;
    }

    private getDenominacion() {
        this._spinnerService.showSpinner();
        this._gestionService.getDenominacionById(this.denominacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._denominacion = resp;
            this.newEditForm.patchValue({
                des: resp.des,
                productoId: this.productos.find(x => x.id === resp.productoId),
                alias: resp.alias,
                permisoLectura: resp.permisoLecturaDataMatrixPublica,
                disenyoEtiquetasIdCaja: this.etiquetas.find(x => x.id === resp.disenyoEtiquetasIdCaja),
                disenyoEtiquetasIdPallet: this.etiquetas.find(x => x.id === resp.disenyoEtiquetasIdPallet),
                grupoEtiquetasIdCaja: this.grupoEtiquetas.find(x => x.id === resp.grupoEtiquetaIdCaja),
                grupoEtiquetasIdPallet: this.grupoEtiquetas.find(x => x.id === resp.grupoEtiquetaIdPallet),
                nombreArchivoImagen: resp.nombreArchivoImagen,
                denominacionIntegracionId: resp.denominacionIntegracionId
            });
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.denominacionId) {
            this._denominacion = {
                des: this.newEditForm.get('des').value,
                productoId: this.newEditForm.get('productoId').value.id,
                alias: this.newEditForm.get('alias').value,
                permisoLecturaDataMatrixPublica: this.newEditForm.get('permisoLectura').value,
                disenyoEtiquetasIdCaja: this.newEditForm.get('disenyoEtiquetasIdCaja').value.id,
                disenyoEtiquetasIdPallet: this.newEditForm.get('disenyoEtiquetasIdPallet').value.id,
                nombreArchivoImagen: this.newEditForm.get('nombreArchivoImagen').value,
                denominacionIntegracionId: this.newEditForm.get('denominacionIntegracionId').value,
            };
            this._spinnerService.showSpinner();
            this._gestionService.createDenominacion(this._denominacion).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp.id) {

                    let grupoEtiquetaCaja = {
                        denominacionId: resp.id,
                        grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasIdCaja').value.id
                    };

                    this._spinnerService.showSpinner();
                    this._gestionService.updateGruposEtiquetaDenominacion(grupoEtiquetaCaja).toPromise().finally(() => {
                        this._spinnerService.hideSpinner();
                    }).then((resp) => {
                            this._dataProvider.refreshDenominaciones();
                            this.refresh.emit(true);
                            this.mensaje.emit('global.success.itemUpdated');
                        },
                        (error) => {
                            this.showError = true;
                            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                        }
                    );

                    if (this.newEditForm.get('grupoEtiquetasIdPallet').value) {
                        let grupoEtiquetaPallet = {
                            denominacionId: resp.id,
                            grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasIdPallet').value.id
                        };

                        this._spinnerService.showSpinner();
                        this._gestionService.updateGruposEtiquetaDenominacion(grupoEtiquetaPallet).toPromise().finally(() => {
                            this._spinnerService.hideSpinner();
                        }).then((resp) => {
                                this._dataProvider.refreshDenominaciones();
                                this.refresh.emit(true);
                                this.mensaje.emit('global.success.itemUpdated');
                            },
                            (error) => {
                                this.showError = true;
                                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                            }
                        );
                    }

                } else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse'});
                }
            });
        } else if (this.newEditForm.valid && this.denominacionId) {
            this._denominacion = {
                id: this.denominacionId,
                des: this.newEditForm.get('des').value,
                productoId: this.newEditForm.get('productoId').value.id,
                alias: this.newEditForm.get('alias').value,
                permisoLecturaDataMatrixPublica: this.newEditForm.get('permisoLectura').value,
                disenyoEtiquetasIdCaja: this.newEditForm.get('disenyoEtiquetasIdCaja').value.id,
                disenyoEtiquetasIdPallet: this.newEditForm.get('disenyoEtiquetasIdPallet').value.id,
                nombreArchivoImagen: this.newEditForm.get('nombreArchivoImagen').value,
                denominacionIntegracionId: this.newEditForm.get('denominacionIntegracionId').value,
            };
            this._spinnerService.showSpinner();
            this._gestionService.updateDenominacion(this._denominacion).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                    let grupoEtiquetaCaja = {
                        denominacionId: this.denominacionId,
                        grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasIdCaja').value.id
                    };

                    this._spinnerService.showSpinner();
                    this._gestionService.updateGruposEtiquetaDenominacion(grupoEtiquetaCaja).toPromise().finally(() => {
                        this._spinnerService.hideSpinner();
                    }).then((resp) => {
                            this._dataProvider.refreshDenominaciones();
                            this.refresh.emit(true);
                            this.mensaje.emit('global.success.itemUpdated');
                        },
                        (error) => {
                            this.showError = true;
                            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                        }
                    );

                    if (this.newEditForm.get('grupoEtiquetasIdPallet').value) {
                        let grupoEtiquetaPallet = {
                            denominacionId: this.denominacionId,
                            grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasIdPallet').value.id
                        };

                        this._spinnerService.showSpinner();
                        this._gestionService.updateGruposEtiquetaDenominacion(grupoEtiquetaPallet).toPromise().finally(() => {
                            this._spinnerService.hideSpinner();
                        }).then((resp) => {
                                this._dataProvider.refreshDenominaciones();
                                this.refresh.emit(true);
                                this.mensaje.emit('global.success.itemUpdated');
                            },
                            (error) => {
                                this.showError = true;
                                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                            }
                        );
                    }


                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }
}